// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2e1wF","consentsList":"PatientConsents_consentsList__x_ztp","consentsListEmpty":"PatientConsents_consentsListEmpty__TR-cs"};